import { Request } from './Request'
import { Agreement } from '../types/agreement'

export default class AgreementRepository {
  private request: Request

  constructor(request: Request) {
    this.request = request
  }

  async loadAgreements() {
    const response = await this.request.get<Agreement[]>('/agreements', undefined, undefined, true)
    return response.data
  }

  async loadAgreement(agreementId: string) {
    const response = await this.request.get<Agreement>(`/agreements/${agreementId}`)
    return response.data
  }

  async postAgreement(name: string, clientId: string, file: File) {
    const form = new FormData()
    form.append('name', name)
    form.append('clientId', clientId)
    form.append('file', file)
    await this.request.post('/agreements', form)
  }

  async acceptAgreement(agreementId: string) {
    await this.request.put(`/agreements/${agreementId}/accept`)
  }

  async rejectAgreement(agreementId: string, reason: string) {
    await this.request.put(`/agreements/${agreementId}/reject`, { rejectReason: reason })
  }
}
